/*设备型号查询*/
import React from 'react'
import {message, Select, Spin} from 'antd';
let isHwsyb = localStorage.getItem("hwsyb") == 1;
import Tools from '../tools/Tools'
const Option = Select.Option;
class DeviceType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            typeList: [],
            value: this.props.imei ? this.props.imei : '',
            selectValue:this.props.imei ? this.props.imei : null,
            loading: false,
            accountId: this.props.accountId,
            dropdownStyle: {
                display: 'none'
            }
        };
        this.getDeviceType = this.getDeviceType.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.onFocus= this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.loading = false; //避免user.html时 两个接口重复请求，并且第二次请求的接口比第一次快

    }
    componentWillMount() {
        this.getDeviceType()
    }

    componentDidMount() {
        this.loading = false;
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.accountId!==this.state.accountId){
            let accountId = nextProps.accountId;
            let imei = nextProps.imei;
            if (accountId) {
                if (imei) {
                    this.setState({
                        accountId: accountId,
                        selectValue: imei
                    });
                } else {
                    this.setState({
                        accountId: accountId,
                        selectValue:''
                    },()=>{
                        this.getDeviceType(true)
                    });
                }
            }
        }
        if(nextProps.imei !== this.state.selectValue){
            this.setState({
                selectValue:nextProps.imei,
            },()=>{
                this.getDeviceType()
            })
        }
    }
    onFocus(){
        this.setState({
            dropdownStyle: {
                display: 'block'
            }
        })
    }
    handleChange(value) {
        // if(value == this.state.selectValue) {
        //     return
        // }
        this.setState({
            selectValue:value?value:null
        },()=>{
            this.getDeviceType();
        })
        if(Object.keys(this.props).includes('setImei')){
            this.props.setImei(value);
        }
        if(this.props.type){
            this.props.type(value);
        }
    }

    handleSelect(value){
        this.setState({
            selectValue:value?value:null,
            dropdownStyle: {
                display: 'none'
            }
        },()=>{
            if(this.props.type){
                  this.props.type(value);
            }
        })
    }

    onBlur() {
        this.setState({
            dropdownStyle: {
                display: 'none'
            }
        })
    }

    /**
     * 获取设备列表
     * @param accountChangeFlag account是否更新
     * @returns {boolean}
     */
    getDeviceType(accountChangeFlag) {
        const {accountId,selectValue}=this.state;
        let url;
        let that = this;
        // if(this.loading) {
        //     setTimeout(this.getDeviceType, 200);
        //     return false;
        // }
        // that.setState({
        //     loading: true
        // });
        if (!Tools.isNull(selectValue)) {
            // that.setState({
            //     loading: false
            // });
            url = '/rest/device/brief/list?id=' + accountId + '&content=' + Tools.removeSpace(selectValue) + "&needCount=true"
            if (this.props.noContainSub){//可以设置不包含下级
                url += `&isTaskSub=0`
            }
            this.loading = true;
            fetch(getNoCacheURL(url), {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                },
                credentials: 'include'
            }).then(function (response) {
                that.loading = false;
                that.setState({
                    loading: false
                });
                if (response.status == 504) {
                    message.error(Strings.rs10392);
                } else if (response.status == 401) {
                    Tools.toLoginPageForSessionExpired(response);
                } else {
                    return response.json();
                }
            }).then(function (data) {
                if(data){
                    if (data.data instanceof Array) {
                        if(data.data.length>0){
                            data.data.forEach(function (item, index) {
                                item.checked = false;
                            });
                            // sessionStorage.setItem("deviceList",JSON.stringify(data.data))
                            that.setState({
                                typeList: data.data,
                                dropdownStyle: {
                                    display: 'block'
                                }
                            });
                        }else{
                            that.setState({
                                typeList: [],
                                dropdownStyle: {
                                    display: 'none'
                                }
                            });
                        }
                    } else if(data.beanList instanceof Array){
                        if(data.beanList.length>0){
                            data.beanList.forEach(function (item, index) {
                                item.checked = false;
                            });
                            // sessionStorage.setItem("deviceList",JSON.stringify(data.beanList))
                            that.setState({
                                typeList: data.beanList,
                                dropdownStyle: {
                                    display: 'block'
                                }
                            });
                        }else{
                            that.setState({
                                typeList: [],
                                dropdownStyle: {
                                    display: 'none'
                                }
                            });
                        }
                    } else {
                        that.setState({
                            typeList: [],
                            dropdownStyle: {
                                display: 'none'
                            }
                        });
                    }
                }
            }).catch(function (error) {
                that.setState({
                    loading: false
                });
            })
        } else {
            //获取包含下级的前100个设备
            url = '/rest/device/list?accountId=' + accountId +'&needCount=true&pageSize=100&status=-1'
           // url = '/rest/loadage/device/status/list?accountId=' + accountId;
            // 缓存中有存储设备列表并且accountId没有切换，存缓存中获取数据，否则调用接口获取
            if(sessionStorage.getItem("first100DeviceList")  && sessionStorage.getItem("first100DeviceListOfAccountId") == accountId && !accountChangeFlag){
                let typeList = JSON.parse(sessionStorage.getItem("first100DeviceList"));
                that.setState({
                    typeList: typeList,
                    loading: false,
                    // dropdownStyle: {
                    //     display: 'block',
                    // }
                });
            }else{
                this.loading = true;
                Tools.fetch(url, 'GET',function (data) {
                    that.loading = false;
                    let originDeviceList = data.data||[];
                    sessionStorage.setItem("first100DeviceList",JSON.stringify(originDeviceList))
                    sessionStorage.setItem("first100DeviceListOfAccountId",accountId)
                    // console.log(originDeviceList)
                    that.setState({
                        typeList: originDeviceList,
                        loading: false
                    })
                })
            }
        }



    }
    render() {
        const {typeList, selectValue, loading,dropdownStyle}=this.state;
        const option = typeList.map(function (item, index) {
            let value = item.name + "(" + item.imei + ")";
            return (
                <Option key={value} value={item.imei} label={value} disabled={isHwsyb && item.isInArrears == 1}
                >{value}</Option>
            )
        });
        return (
            <Spin delay={2000} spinning={loading} style={{display: 'inline-block'}}>
                <Select
                        style={{width: '250px'}}
                        dropdownStyle={dropdownStyle}

                        // defaultValue={this.props.imei?this.props.imei:""}
                        combobox
                        notFoundContent={Strings.rs10297}
                        defaultActiveFirstOption={false}
                        dropdownMatchSelectWidth={false}
                        allowClear={true}
                        showArrow={true}
                        filterOption={false}
                        showSearch={true}
                        onSearch={this.handleChange}
                        // onChange={this.handleChange}
                        onSelect={this.handleSelect}
                        onClear={()=>{
                            this.handleChange(null)
                            this.onFocus()
                        }}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        optionLabelProp={'label'}
                        value={selectValue?selectValue:null}
                        placeholder={Strings.rs10424}>
                    {option}
                </Select>
            </Spin>
        )
    }
}
export default DeviceType
